export const ToastMessage = {
  FAILURE:
    "Action failed. The server may be temporarily down. Please try again in a few minutes.",
  PAYMENT_GATEWAY_FAILURE:
    "Our payment gateway provider is currently unavailable.",
  UNAVAILABLE: "This action is currently unavailable.",
};
